module.exports = __webpack_public_path__ + "assets/img/partners4.8967d324.jpg";